module.exports = __webpack_public_path__ + "assets/img/d270533e78ef300fffeed252f1a7685a.png";